import AccordionSection from 'components/contentBlocks/AccordionSection';
import React from 'react';
import { cmsTextContentProp } from 'utils/proptypes/modules/textProps';
import transformTextSection from 'libs/wordpress/utils/transfromTextSection';

// Pure CMS data transformation before we send it to the "real" block!
const AccordionBlock = ({ content = {} }) => {
    const { items } = content;

    const transformedItems = items
        ? items.map(item => ({
              anchorTag: item.anchor_tag,
              label: item.label,
              data: transformTextSection(item.data),
          }))
        : [];

    return <AccordionSection borderTop="none" items={transformedItems} />;
};

AccordionBlock.propTypes = {
    content: cmsTextContentProp,
};

export default AccordionBlock;
